import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/wechat.png'
import _imports_1 from '@/assets/flash.png'


const _hoisted_1 = { class: "pay-code-base" }
const _hoisted_2 = { class: "code-base" }
const _hoisted_3 = { class: "super-box" }
const _hoisted_4 = { class: "header-bar" }
const _hoisted_5 = { class: "product-part" }
const _hoisted_6 = { class: "product-info" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "timer-info" }
const _hoisted_9 = { class: "timer" }
const _hoisted_10 = { class: "product-display" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "tag"
}
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = { class: "main" }
const _hoisted_16 = {
  key: 0,
  class: "bottom-bar"
}
const _hoisted_17 = { class: "tag" }

import {
  showVIPDialogue,
  showPayCodeDialogue,
} from "@/components/Dialogues/useData/useDialogues";
import qs from "qs";

import { mobilePayUrl, wxMobilePayUrl } from "@/config/apiDomain";
import { openAgreement } from "@/components/Dialogues/useData/login";
import { isMobile } from "@/data/pubilc";
import { isCompactMode } from "@/data/pubilc";
import { computed, onMounted, reactive, ref, watch, watchEffect } from "vue";
import {
  requestProduct,
  productInfo,
  productItem,
  productIndex,
  requestPayInfo,
  payInfo,
  startPoll,
  stopPoll,
} from "./useData/usePayData";

import { ElMessage } from "element-plus";
import { getStorage, setStorage } from "@/utils/storage";


export default /*@__PURE__*/_defineComponent({
  __name: 'BuyVIPDialogues',
  setup(__props) {

const dialogueWidth = computed(() => {
  return isCompactMode.value ? "100%" : "800px";
});

watch(
  showVIPDialogue,
  (nVal) => {
    if (nVal) {
      requestProduct();
    } else {
      // if (timerFlag > 0) {
      //   clearInterval(timerFlag);
      //   timerFlag = -1;
      // }
    }
  },
  {
    immediate: true,
  }
);

watch(productInfo, (newVal) => {
  if (newVal.length > 0) {
    startTime();
  }
});

const isPermanentVer = (index: number) => {
  const item = productInfo[index];
  const plan_name = item.plan_name;

  return plan_name === "终身会员";
};

const displayPriceTag = (index: number) => {
  const item = productInfo[index];
  return item.price;

  // const plan_name = item.plan_name;
  // if (plan_name === "终身会员") {
  //   return item.price;
  // }
  //
  // if (plan_name.includes("半年")) {
  //   return (item.price / 6).toFixed(1);
  // }
  //
  // if (plan_name.includes("年度")) {
  //   return (item.price / 12).toFixed(1);
  // }
  //
  // if (plan_name.includes("月")) {
  //   return item.price;
  // }
};

// 判断是否微信环境
const isWeiXin = () => {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (
    ua.match(/MicroMessenger/i) == "micromessenger" &&
    ua.match(/wxwork/i) != "wxwork"
  ) {
    return true;
  } else {
    return false;
  }
};

const mobilePay = (data: any) => {
  let query = {
    soft_id: getStorage("soft_id"),
    ekey: getStorage("ekey"),
    source: getStorage("source"),
  };
  setStorage("isPay", JSON.stringify({ orderId: data.id }));
  if (isWeiXin()) {
    window.location.href = `${wxMobilePayUrl}/api/show-order?order_id=${
      data.id
    }&${qs.stringify(query)}`;
    return;
  }
  window.location.href = `${mobilePayUrl}/pay/pay.html?order_id=${
    data.id
  }&skip=order&${qs.stringify(query)}`;
};

const pay = async () => {
  //

  try {
    const payData = await requestPayInfo();

    if (isCompactMode.value) {
      mobilePay(payData);
      startPoll();

      return;
    }

    showPayCodeDialogue.value = true;
    startPoll();
  } catch (error: any) {
    const msg = error.msg || "获取商品信息失败";

    ElMessage.error(msg);

    console.log(error);
  }
};

let timerFlag = -1;
const timerCount = ref(3600);

const startTime = () => {
  if (timerFlag > 0) {
    clearInterval(timerFlag);
    timerFlag = -1;
    timerCount.value = 3600;
  }

  timerFlag = setInterval(() => {
    timerCount.value = timerCount.value - 1;
    if (timerCount.value === 0) {
      clearInterval(timerFlag);
      timerFlag = -1;
      timerCount.value = 3600;
    }
  }, 1000);
};

const displayTime = computed(() => {
  const time = timerCount.value;
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
});

const didClose = () => {
  if (timerFlag > 0) {
    clearInterval(timerFlag);
    timerFlag = -1;
    timerCount.value = 3600;
  }

  showVIPDialogue.value = false;
};

const payCodeClose = (done) => {
  //
  console.log("payCodeClose");
  stopPoll();
  done();
};

const _openAgreement = () => {
  //
  openAgreement();
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showVIPDialogue),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showVIPDialogue) ? (showVIPDialogue).value = $event : null)),
    width: dialogueWidth.value,
    class: "custom-dialog",
    "align-center": "",
    "before-close": didClose,
    "show-close": false,
    "destroy-on-close": true,
    style: {
      '--el-dialog-bg-color': 'none',
      '--el-dialog-padding-primary': '0',
      '--el-dialog-box-shadow': 'none',
    },
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_dialog, {
        "before-close": payCodeClose,
        modelValue: _unref(showPayCodeDialogue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showPayCodeDialogue) ? (showPayCodeDialogue).value = $event : null)),
        width: "300",
        "append-to-body": "",
        "align-center": "",
        style: {
        '--el-dialog-padding-primary': '10',
        '--el-dialog-box-shadow': 'none',
      }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                style: {"width":"100%","height":"100%"},
                src: _unref(payInfo).url,
                fit: "cover"
              }, null, 8, ["src"]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "center-logo" }, [
                _createElementVNode("img", {
                  style: {"width":"26px","height":"26px"},
                  src: _imports_0,
                  fit: "cover"
                })
              ], -1))
            ]),
            _createElementVNode("span", { class: "bottom-info" }, [
              _cache[4] || (_cache[4] = _createTextVNode(" 推荐使用微信扫码支付 ")),
              _createElementVNode("span", { class: "sub" }, [
                _cache[3] || (_cache[3] = _createTextVNode(" 支付即视为您同意")),
                _createElementVNode("text", {
                  class: "btn",
                  onClick: _openAgreement
                }, "《会员协议》")
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["custom-body", {
          'custom-body-mobile': _unref(isCompactMode),
        }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "close",
              onClick: didClose
            }, [
              _createVNode(_component_el_icon, {
                size: 20,
                color: `white`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Close)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "left" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "icon"
                }),
                _createElementVNode("div", { class: "title-part" }, [
                  _createElementVNode("div", { class: "title" }, "DeepSeek-R1 671B满血版（无限量使用）"),
                  _createElementVNode("div", { class: "sub-title" }, " API高速专线·永不卡顿·永不崩溃·极速响应 ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "即将涨价30%", -1)),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(displayTime.value), 1)
                ])
              ])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "person-info" }, [
              _createElementVNode("div", { class: "h-div" }),
              _createElementVNode("div", { class: "title" }, "已经有136886个用户开通会员"),
              _createElementVNode("div", { class: "h-div" })
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productInfo), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["item", { 'item-selected': i == _unref(productIndex) }]),
                  key: i,
                  onClick: ($event: any) => (productIndex.value = i)
                }, [
                  (isPermanentVer(i))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "最多人选"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.plan_name), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sub" }, "¥", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(displayPriceTag(i)), 1)
                  ])
                ], 10, _hoisted_11))
              }), 128))
            ]),
            (_unref(productInfo).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "pay-btn",
                    onClick: pay
                  }, [
                    _createTextVNode(_toDisplayString(_unref(isCompactMode) ? "前往支付" : "立即支付") + " ", 1),
                    _createElementVNode("div", _hoisted_17, "¥" + _toDisplayString(_unref(productItem).price), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})